<template>
  <expand-transition v-if="subaccountInvite">
    <sb-banner
      v-if="isKYCApproved"
      variation="info"
      class="invitation-banner"
    >
      <span class="left-container">
        <strong>
          {{ $t(`KycApproved.Heading`, { parentOrgName: subaccountInvite?.business_name }) }}
        </strong>
        <br>
        {{ $t(`KycApproved.Description`) }}
      </span>
      <div>
        <sb-button @click="reviewInvitation">
          {{ $t('buttonText') }}
        </sb-button>
      </div>
    </sb-banner>
    <sb-banner
      v-else
      variation="danger"
      class="invitation-banner"
    >
      <span class="left-container">
        <strong>
          {{ $t(`KycNotApproved.Heading`, { parentOrgName: subaccountInvite?.business_name }) }}
        </strong>
        <br>
        {{ $t(`KycNotApproved.Description`) }}
        <help-center-link link-key="kyc">
          {{ $t('KycNotApproved.LinkText') }}
        </help-center-link>
      </span>
      <div>
        <sb-button
          :disabled="!isKYCApproved"
          @click="reviewInvitation"
        >
          {{ $t('buttonText') }}
        </sb-button>
        <sb-tooltip
          v-if="!isKYCApproved"
          variation="secondary"
          orientation="bottom"
        >
          {{ $t('KycNotApproved.TooltipText') }}
        </sb-tooltip>
      </div>
    </sb-banner>
  </expand-transition>
</template>
<script>

import MembershipService from '@/services/membership/membership.service'
import KYCWatcher from '@/mixins/KYCWatcher'

export default {
  name: 'SubaccountInvitationBanner',
  mixins: [KYCWatcher],
  data () {
    return {
      subaccountInvite: null
    }
  },
  async mounted () {
    const oneIdClaim = this.$shipBobStore.getters['user/getOneIdClaim']
    const organizationId = oneIdClaim.Lorg
    const organizationType = oneIdClaim.lorg_type
    const merchantOrgType = '4fd26cc1-36ee-42ea-ba05-d38a369e35f6'
    let organization = null

    const response = await MembershipService.getOrganization(organizationId)

    if (response.success) {
      organization = response.data
    }

    if (organization != null &&
        organizationType === merchantOrgType &&
        organization.parent_organization_id == null) {
      const response = await MembershipService.getSubaccountInvite(organizationId)

      if (response.success) {
        this.subaccountInvite = response.data
      }
    }
  },
  methods: {
    reviewInvitation () {
      this.$router.push({ path: '/user-management/company-profile?invite=true' })
    }
  },
  i18n: {
    messages: {
      'en-US': {
        title: 'You have an invitation to join the ',
        subTitle: 'Review the invitation details to accept or reject.',
        buttonText: 'Review Invitation',
        KycApproved: {
          Heading: 'You have an invitation to join the ‘{parentOrgName}’ account.',
          Description: 'Review the invitation details to accept or reject.'
        },
        KycNotApproved: {
          Heading: "You're invited to join the ‘{parentOrgName}’ account.",
          Description: 'To accept or reject the invitation, ',
          LinkText: 'complete business verification',
          TooltipText: 'View invitation is disabled.\n\nPlease complete business verification to view invitation.'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './scss/banner';

.tooltip {
  padding: 1rem !important;
  max-width: 30%;
  white-space: normal;
  text-align: left;
}

.invitation-banner {
  width: calc(100% - 2rem);
  margin-top: 0.5rem;
  margin-left: 1rem;

  :deep(.banner-content) {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-container {
      max-width: 75%;
    }
  }
}
</style>
